const AdminListeBlancheDeleteRemoveStyle = {
  bg: "white",
  flexWrap: "wrap",
  width: "100%",
};

export { AdminListeBlancheDeleteRemoveStyle };
